import dynamic from "next/dynamic";

import { useGetIsOpenChatContainer, useToggleChatContainer } from "_common/hooks/global";
import { useGetDeviceType }                                  from "_common/hooks/global";
import MobileBottomDrawer                                    from "_components/atoms/mobileBottomDrawer";

import PlayerContainer from "./components/playerContainer";
import useStyles       from "./styles";

const BroadcastBottom      = dynamic ( () => import ( "_components/templates/BroadcastBottom" ) );
const ChatContainerWrapper = dynamic ( () => import ( "_components/features/chat/containerWrapper" ) );

const component = props => {
	const {
		sessions,
		broadcastId,
		theatreModeToggle,
		isMobile
	} = props;

	const { classes }         = useStyles ( { theatreModeToggle } );
	const isOpenChatContainer = useGetIsOpenChatContainer ();
	const toggleChatContainer = useToggleChatContainer ();

	const deviceType       = useGetDeviceType ();
	const isMobileOrTablet = deviceType === "mobile" || deviceType === "tablet" || isMobile;

	const chatContainer = (
		<ChatContainerWrapper
			broadcastId = { broadcastId }
			isMobile = { isMobile }
		/>
	);

	return (
		<div className = { classes.mainContainer }>
			<div className = { classes.playerBodyContainer }>
				<PlayerContainer
					broadcastId = { broadcastId }
					isStreamer = { false }
				/>

				{
					!theatreModeToggle && sessions?.length ? (
						<BroadcastBottom
							broadcastId = { broadcastId }
							isMobile = { isMobile }
							sessions = { sessions }
						/>
					) : null
				}
			</div>

			{
				( !isMobileOrTablet ) ? (
					chatContainer
				) : null
			}

			<MobileBottomDrawer
				noBorderRadius
				noOverlay
				closeOnClickOutside = { false }
				isOpen = { isMobileOrTablet && isOpenChatContainer }
				onClose = { () => toggleChatContainer ( false ) }
				zIndex = { 10 }
			>
				{chatContainer}
			</MobileBottomDrawer>

		</div>
	);
};

export default component;
